import { defineRecipe } from "@chakra-ui/react"

export const buttonRecipe = defineRecipe({
  base: {
    fontFamily: "body"
  },
  variants: {
    variant: {
      solid: {
        bg: "brand.300",
        color: "white",
        _hover: { bg: "darkBlue.100" },
        _disabled: { bg: "brand.100", color: "white" },
        pt: 2,
        pb: 2,
        pl: 4,
        pr: 4,
        borderRadius: 5,
        fontWeight: "bold",
        cursor: "pointer",
      },
      outline: {
        borderWidth: "1px",
        borderColor: "gray.300",
        color: "gray.700",
        bg: "transparent",
        pt: 2,
        pb: 2,
        pl: 4,
        pr: 4,
        borderRadius: 5,
        fontWeight: "bold",
        cursor: "pointer",
        _hover: { bg: "gray.100" },
        _disabled: { borderColor: "gray.100", color: "gray.300", cursor: "not-allowed" },
        _dark: { borderColor: "whiteAlpha.400", color: "white", _hover: { bg: "whiteAlpha.200" } },
      },
      tabSelected: {
        borderTopRadius: 5,
        border: "1px solid",
        borderBottom: "none",
        borderBottomRadius: 0,
        borderColor: "gray.300",
        color: "text.primary",
        bg: "card.bg",
        pt: 2,
        pb: 2,
        pl: 4,
        pr: 4,
        fontWeight: "bold",
        cursor: "pointer",
        _hover: { bg: "gray.100" },
        _disabled: { borderColor: "gray.100", color: "gray.300", cursor: "not-allowed" },
      },
      tabUnselected: {
        color: "text.primary",
        bg: "card.bg",
        borderTopRadius: 5,
        borderBottomRadius: 0,
        pt: 2,
        pb: 2,
        pl: 4,
        pr: 4,
        fontWeight: "bold",
        cursor: "pointer",
        _hover: { bg: "gray.100" },
        _disabled: { borderColor: "gray.100", color: "gray.300", cursor: "not-allowed" },
      },
    },
  },
})